import { useCallback, useContext, useEffect } from 'react';

import { CommercePaymentMethods, Summary } from '..';
import { Form } from '../../../../../../../../../shared/components';
import {
  GenericDataFormContext,
  QUOTATION_BUTTON,
  QuotationInfoContext,
  QuotationStep,
  QuotationStepButtons,
} from '../../../../../shared';
import { Tabs } from '@hdi-seguros/web-components.tabs';

import { StepFourFormContext } from '../../contexts/StepFourForm';

import {
  generateInputID,
  getCoverageAndActivityKeyByID,
} from '../../../../../AP/Steps/StepThree/components/Quotation/utils';

import './index.css';

export const CommerceQuotation = () => {
  const {
    clearPrimaFieldsOnFormChange,
    labelButton,
    quotationResponse,
    setLabelButton,
    stepFourCommerceQuotationForm,
    quotationTabs,
    activeTab,
    setActiveTab,
    createTabs,
    handlerOnClick,
  } = useContext(StepFourFormContext);
  const { allCoveragesPerPlan, setFormValues } = useContext(GenericDataFormContext);
  const { setCurrentStep } = useContext(QuotationInfoContext);

  const handlePressTab = (activeTab: string) => setActiveTab(activeTab);

  const onPressBackButton = useCallback(async () => {
    setFormValues(stepFourCommerceQuotationForm.getFieldsValue());
    if (quotationResponse) setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
    setCurrentStep(QuotationStep.THREE);
  }, [
    quotationResponse, 
    setCurrentStep, 
    setLabelButton,
    setFormValues,
    stepFourCommerceQuotationForm,
  ]);

  const onChangeForm = useCallback(
    (changedFields: any[]) => {
      if (quotationResponse) {
        setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
        clearPrimaFieldsOnFormChange();
      }

      const nameOfFieldChanged: string = changedFields[0].name[0];
      const valueChanged = changedFields[0].value;

      const { activityKey, id } =
        getCoverageAndActivityKeyByID(nameOfFieldChanged);

      const tabKey = activityKey.split('-')[2];

      const planSelected = stepFourCommerceQuotationForm.getFieldValue(
        `plan-tab-${tabKey}`
      );

      const allCoveragesByTab = allCoveragesPerPlan.find(
        (el) => (el.plan as string) === String(planSelected)
      )?.coverages;

      const coverageCode = allCoveragesByTab?.find(
        (el) => el.id === id
      )?.codigo;

      if (coverageCode) {
        const relatedCoverages = allCoveragesByTab?.filter(
          (el) => el.codigoCoberturaRelacionada === coverageCode
        );

        relatedCoverages.forEach(({ porcentajeSumaAsegegurada, id }) => {
          const checkboxName = generateInputID(id, activityKey, 'checkbox');

          if (stepFourCommerceQuotationForm.getFieldValue(checkboxName)) {
            const inputName = generateInputID(id, activityKey);

            stepFourCommerceQuotationForm.setFieldValue(
              inputName,
              Math.round(
                valueChanged * (Number(porcentajeSumaAsegegurada) / 100)
              )
            );
          }
        });
      }
    },
    [
      setLabelButton,
      allCoveragesPerPlan,
      stepFourCommerceQuotationForm,
      quotationResponse,
      clearPrimaFieldsOnFormChange,
    ]
  );

  useEffect(() => {
    setActiveTab(1);
    createTabs();
  }, [createTabs]);

  return (
    <>
      <Form
        formProps={{
          form: stepFourCommerceQuotationForm,
          name: 'quotation-commerce-tab-form',
          onFieldsChange: onChangeForm,
        }}
      >
        <Tabs
          handlePressTab={handlePressTab}
          activeKey={activeTab}
          items={quotationTabs}
        />
      </Form>

      {quotationResponse && (
        <>
          <CommercePaymentMethods />

          <Summary />
        </>
      )}

      <QuotationStepButtons
        label={labelButton}
        onClick={handlerOnClick}
        onPressBackButton={onPressBackButton}
      />
    </>
  );
};
